export default function Hero() {
  const scrollToSection = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
      style={{ backgroundColor: 'oklch(var(--background-50))' }}
    >
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-6"
              style={{ backgroundColor: 'oklch(var(--primary-100) / 0.7)', color: 'oklch(var(--primary-700))' }}
            >
              <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: 'oklch(var(--primary-500))' }}></span>
              <span className="text-xs font-medium">热门漫画</span>
              <span className="text-xs opacity-50">·</span>
              <span className="text-xs font-medium">下拉式阅读</span>
              <span className="text-xs opacity-50">·</span>
              <span className="text-xs font-medium">无限滚动</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              甜柚漫画 — 手机畅读 免费全集漫画平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading mb-8">
              竖屏下拉，随时随地畅享热门漫画
            </p>

            <div className="max-w-xl mx-auto lg:mx-0 space-y-3 mb-8">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                甜柚漫画是国内领先的竖屏下拉式漫画阅读平台，专为手机用户打造。
                采用无限滚动技术，手指下滑即可无缝畅读，无需翻页等待。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                平台收录 5000+ 热门漫画，玄幻、都市、仙侠、恋爱、悬疑全品类覆盖，
                全部免费全集阅读。每日 200+ 章节实时更新，热门连载同步上线。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold" style={{ color: 'oklch(var(--primary-500))' }}>5000+</div>
                <div className="text-xs text-foreground-500 mt-1">免费漫画资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold" style={{ color: 'oklch(var(--accent-500))' }}>200+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新章节</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold" style={{ color: 'oklch(var(--secondary-500))' }}>800万+</div>
                <div className="text-xs text-foreground-500 mt-1">月活跃读者</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollToSection('#ranking')}
                className="w-full sm:w-auto px-8 py-3 rounded-md font-medium text-sm whitespace-nowrap cursor-pointer transition-all duration-200 hover:opacity-90"
                style={{ backgroundColor: 'oklch(var(--primary-500))', color: 'oklch(var(--background-50))' }}
              >
                立即开始阅读
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={() => scrollToSection('#app')}
                className="w-full sm:w-auto px-8 py-3 rounded-md font-medium text-sm whitespace-nowrap cursor-pointer transition-all duration-200 border"
                style={{
                  borderColor: 'oklch(var(--background-300))',
                  color: 'oklch(var(--foreground-700))',
                  backgroundColor: 'oklch(var(--background-50))',
                }}
              >
                下载 APP
                <i className="ri-download-line ml-2"></i>
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <div
                className="absolute -inset-4 rounded-3xl opacity-30 blur-2xl"
                style={{ backgroundColor: 'oklch(var(--primary-300))' }}
              ></div>
              <div
                className="absolute inset-0 rounded-2xl opacity-20 blur-xl"
                style={{ backgroundColor: 'oklch(var(--accent-300))' }}
              ></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustration%20of%20a%20smartphone%20held%20vertically%20in%20hand%2C%20displaying%20vibrant%20colorful%20manga%20panels%20scrolling%20downward%20on%20screen%2C%20speech%20bubbles%20and%20action%20lines%20visible%2C%20soft%20coral%20and%20cream%20warm%20gradient%20background%2C%20cozy%20ambient%20lighting%2C%20modern%20flat%20illustration%20style%2C%20editorial%20quality%2C%20clean%20composition%2C%20reading%20in%20bed%20atmosphere&width=700&height=900&seq=hero-main&orientation=portrait"
                alt="甜柚漫画 — 手机竖屏下拉式阅读体验"
                className="relative w-full h-auto rounded-2xl"
                style={{ maxHeight: '520px', objectFit: 'contain', objectPosition: 'center' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}